'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AddCatalogItem = require('./components/AddCatalogItem.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AddCatalogItem).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/add-catalog-item/index.js
// module id = 1030
// module chunks = 0